import { render, staticRenderFns } from "./provisional-advancement-table.vue?vue&type=template&id=219538f2&scoped=true&"
import script from "./provisional-advancement-table.vue?vue&type=script&lang=ts&"
export * from "./provisional-advancement-table.vue?vue&type=script&lang=ts&"
import style0 from "./provisional-advancement-table.vue?vue&type=style&index=0&id=219538f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219538f2",
  null
  
)

export default component.exports